import React, { useEffect, useState } from 'react';
import SenMessages from './SenMessages';
import {
  Box,
  TextField,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Typography,
} from '@mui/material';
import { useApiContext } from '../../../Utils/ApiContext/ApiContext';
import ApiServices from '../../../Utils/ApiServices/ApiServices';
import { getDecryptedAccessToken, getDecryptedUserType } from '../../../Utils/LoginUserDetails.js/LoginUserSavedDetails';

const MessagesUser = () => {
  const { loading, fetchData, patients } = useApiContext();
  const [search, setSearch] = useState('');
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [filteredData, setFilteredData] = useState({ data: [] });

  const LoginUserType = getDecryptedUserType();
  const accessToken = getDecryptedAccessToken();
console.log("filteredData",filteredData)
  useEffect(() => {
    const fetchUserData = async () => {
      if (LoginUserType === 'Patient') {
        try {
          const response = await ApiServices.get('/apis/default/portal/practitioner', {
            Authorization: `Bearer ${accessToken}`,
          });

          // Only include practitioners where is_chat_allowed is true
          const allowedPractitioners = (response?.data || []).filter(
            (practitioner) => practitioner.is_chat_allowed === true
          );

          setFilteredData({ data: allowedPractitioners });
        } catch (error) {
          console.error('Error fetching practitioners:', error);
        }
      } else {
        fetchData('/apis/default/api/patient');
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    if (LoginUserType !== 'Patient') {
      setFilteredData(patients);
    }
  }, [patients]);

  const filteredList = filteredData.data?.filter((item) => {
    const fullName = LoginUserType === 'Patient'
      ? item.name?.toLowerCase()
      : `${item.fname || ''} ${item.lname || ''}`.toLowerCase();
    return fullName.includes(search.toLowerCase());
  });

  return (
    <Box display="flex" height="95vh">
      {/* Left Panel */}
      <Box width="20%" border="1px solid #ccc" p={2} overflow="auto">
        <TextField
          fullWidth
          label="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          variant="outlined"
          size="small"
        />
        {loading && LoginUserType !== 'Patient' ? (
          <CircularProgress sx={{ mt: 2 }} />
        ) : (
          <List>
            {filteredList?.map((item) => {
              const fullName =
                LoginUserType === 'Patient'
                  ? item.name
                  : `${item.fname} ${item.lname}`;

              const isSelected =
                selectedPatient?.pid === item.pid ||
                selectedPatient?.id === item.id;

              return (
                <ListItem
                  key={item.pid || item.id}
                  button
                  selected={isSelected}
                  onClick={() => setSelectedPatient(item)}
                  sx={{
                    backgroundColor: isSelected ? '#e0f7fa' : 'inherit',
                    borderRadius: '6px',
                    mt: 1,
                  }}
                >
                  <ListItemText primary={fullName} />
                </ListItem>
              );
            })}
          </List>
        )}
      </Box>

      {/* Right Panel */}
      <Box flexGrow={1} p={2}>
        {selectedPatient ? (
          <>
            <SenMessages patient={selectedPatient} />
          </>
        ) : (
          <Typography variant="body1" color="textSecondary" mt={2}>
            Select a {LoginUserType === 'Patient' ? 'practitioner' : 'patient'} to start chatting
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default MessagesUser;
